

// Utility to help claculte tutorial "completeness" for classic users
// They need to have atleast 1 passing grade in all SP's

import { each } from "highcharts";

export function wasTutorialModuleCompleted(lp1Overview, lp2Overview, lp3Overview) {
    if (lp1Overview === undefined || lp2Overview === undefined || lp3Overview === undefined) {
        return false;
    }

    try {
        const bestScore1AsFloat = parseFloat(lp1Overview['best-score']);
        const bestScore2AsFloat = parseFloat(lp2Overview['best-score']);
        const bestScore3AsFloat = parseFloat(lp3Overview['best-score']);

        // lp's in classic aren't scored like normal plays
        // they are either 0.0 or 100.0 for passing and failing

        if (bestScore1AsFloat >= 100.0 && bestScore2AsFloat >= 100.0 && bestScore3AsFloat >= 100.0) {
            return true;
        }
    }
    catch(e) {
        // If something was missing, then it's not a valid play
        return false;
    }
}

export function getDynamicJournalConfiguration(user, menuConfig, pre) {
    if (user === undefined || user === null) {
        return undefined;
    }

    if (user.class_access_dcoaching !== 1) {
        return undefined;
    }

    if (menuConfig === undefined || menuConfig === null) {
        return undefined;
    }

    const {
        prompts,
        prePrompts,
        loosePrePrompts,
        loosePrompts
    } = menuConfig;

    if (!loosePrompts && !loosePrePrompts) {
        return undefined;
    }

    const _prompts = pre ? (prePrompts || loosePrePrompts) : (prompts | loosePrompts);

    if (_prompts === undefined || _prompts.length === 0) {
        return undefined;
    }

    let results: any[] = [];

    each(_prompts, _prompt => {
        results.push({
            prompt: _prompt
        });
    });

    return results;
}
